import { render, staticRenderFns } from "./plan-preview.vue?vue&type=template&id=1f6ff8c6&scoped=true"
import script from "./plan-preview.vue?vue&type=script&lang=js"
export * from "./plan-preview.vue?vue&type=script&lang=js"
import style0 from "./plan-preview.vue?vue&type=style&index=0&id=1f6ff8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ff8c6",
  null
  
)

export default component.exports